import React from "react";

const FlashIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
    <path d="M8.32466 18.9584C8.15799 18.9584 8.02466 18.9251 7.92466 18.8834C7.59132 18.7584 7.02466 18.3501 7.02466 17.0584V11.6834H5.07466C3.95799 11.6834 3.55799 11.1584 3.41632 10.8501C3.27466 10.5334 3.14966 9.89177 3.88299 9.05011L10.1913 1.88344C11.0413 0.916774 11.733 0.98344 12.0663 1.10844C12.3997 1.23344 12.9663 1.64177 12.9663 2.93344V8.30844H14.9163C16.033 8.30844 16.433 8.83344 16.5747 9.14177C16.7163 9.45844 16.8413 10.1001 16.108 10.9418L9.79966 18.1084C9.20799 18.7834 8.69132 18.9584 8.32466 18.9584ZM11.608 2.28344C11.583 2.31677 11.408 2.40011 11.133 2.71677L4.82466 9.88344C4.59132 10.1501 4.55799 10.3168 4.55799 10.3501C4.57466 10.3584 4.72466 10.4418 5.07466 10.4418H7.64966C7.99132 10.4418 8.27466 10.7251 8.27466 11.0668V17.0668C8.27466 17.4834 8.34966 17.6668 8.38299 17.7168C8.40799 17.6834 8.58299 17.6001 8.85799 17.2834L15.1663 10.1168C15.3997 9.85011 15.433 9.68344 15.433 9.65011C15.4163 9.64177 15.2663 9.55844 14.9163 9.55844H12.3413C11.9997 9.55844 11.7163 9.27511 11.7163 8.93344V2.93344C11.7247 2.51677 11.6413 2.34177 11.608 2.28344Z" fill="#006300"/>
    </g>
  </svg>
);

export default FlashIcon;
